import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { Subject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { ModalSettings } from "../modal/modal-models";
import { RaskModalService } from "../modal/rask-modal.service";
import { INamedSearchFilter } from "../save-search-filter/model/INamedSearchFilter";
import { SaveSearchFilterService } from "../save-search-filter/service/save-search-filter.service";
import { ITab } from "../tabs/tab/itab";
import { TabComponent } from "../tabs/tab/tab.component";
import { TabsComponent } from "../tabs/tabs.component";

@Component({
    selector: "rask-saved-search-filter-tabs",
    templateUrl: "./saved-search-filter-tabs.component.html",
    styleUrls: ["./saved-search-filter-tabs.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TabsComponent,
        TabComponent
    ]
})
export class SavedSearchFilterTabsComponent implements OnInit, OnDestroy {
    @Output() filterChanged = new EventEmitter<INamedSearchFilter>();
    @Input() webbinstallningarKey: string;

    protected sokningar: INamedSearchFilter[];

    private readonly $unsubscribe: Subject<void> = new Subject();
    private readonly modalService = inject(RaskModalService);
    private readonly searchService = inject(SaveSearchFilterService);

    confirmDeleteSparadSokning(tab: ITab) {
        this.modalService.confirm(new ModalSettings("Ta bort sökning", `Är du säker på att du vill ta bort "${tab.label}"`))
            .pipe(take(1))
            .subscribe((ok) => {
                if (ok === ConfirmDialogResponse.save && this.sokningar.find(x => x.namn === tab.label)) {
                    this.searchService.deleteSearchFilterByNamn(tab.label, this.webbinstallningarKey);
                }
            });
    }

    ngOnDestroy(): void {
        this.$unsubscribe.next();
        this.$unsubscribe.complete();
    }

    ngOnInit(): void {
        this.searchService.getSavedFiltersInstallningar(this.webbinstallningarKey);
        this.searchService.minaSparadeFilter.pipe(takeUntil(this.$unsubscribe))
            .subscribe(x => {
                this.sokningar = Object.assign([], x);
            });
    }

    setSokning(sparadSokningNamn: INamedSearchFilter) {
        if (sparadSokningNamn) {
            this.filterChanged.emit(sparadSokningNamn);
        }
    }
}
